export const GLOBAL_STATE = 'TeachingWorkload'

export const TEACHING_WORKLOAD_APPROVAL_ALL = 'TEACHING_WORKLOAD_APPROVAL_ALL' as const
export const TEACHING_WORKLOAD_APPROVAL_BY_ID = 'TEACHING_WORKLOAD_APPROVAL_BY_ID' as const
export const TEACHING_WORKLOAD_APPROVAL_SUBMIT = 'TEACHING_WORKLOAD_APPROVAL_SUBMIT' as const
export const TEACHING_WORKLOAD_APPROVAL_RESPONSE = 'TEACHING_WORKLOAD_APPROVAL_RESPONSE' as const
export const TEACHING_WORKLOAD_REPORT_BULK = 'TEACHING_WORKLOAD_REPORT_BULK' as const
export const TEACHING_WORKLOAD_REPORT_SINGLE = 'TEACHING_WORKLOAD_REPORT_SINGLE' as const
